import errorHandler from './errorHandler';
export function getPriceDetails(options, price, compareAtPrice) {
  const priceDetails = {};
  const hasCompareAtPrice = parseInt(compareAtPrice) > 0;
  priceDetails.hasCompareAtPrice = hasCompareAtPrice;
  const shopifyMoneyFormat = getShopifyCurrencyFormat();
  const formatMoneyFunc = Shopify.formatMoney || formatMoney;
  if (formatMoneyFunc && shopifyMoneyFormat && !options.formatMoneyOverride) {
    try {
      priceDetails.price = formatMoneyFunc(price * 100, shopifyMoneyFormat);
      priceDetails.compareAtPrice = hasCompareAtPrice
        ? formatMoneyFunc(compareAtPrice * 100, shopifyMoneyFormat)
        : '';
      return priceDetails;
    } catch (err) {
      errorHandler(err, true);
    }
  }

  const currencySymbol = options.currencyToken || '$';
  priceDetails.price = `${currencySymbol}${
    options.hideDecimal ? price.split('.')[0] : price
  }`;

  priceDetails.compareAtPrice = hasCompareAtPrice
    ? `${currencySymbol}${
        options.hideDecimal ? compareAtPrice.split('.')[0] : compareAtPrice
      }`
    : '';

  return priceDetails;
}

export function isProductPage() {
  return window.location.href.toLowerCase().indexOf('/products/') >= 0;
}

export function isCartPage() {
  return window.location.href.toLowerCase().indexOf('/cart') >= 0;
}

export function getProductJsonUrl() {
  const pathname = window.location.pathname;
  const index = pathname.lastIndexOf('/') + 1;
  return `/products/${pathname.substr(index)}`;
}

export function getAddOnProduct(addOnId) {
  const intId = parseInt(addOnId);
  for (let i = 0; i < window.upsell.addons.length; i++) {
    const addOn = window.upsell.addons[i];
    if (addOn.variantOptions) {
      const variant = addOn.variantOptions.find(function(variantOption) {
        return variantOption.id === intId;
      });
      if (variant) {
        return {
          title: addOn.title,
          variant: variant.title,
          price: variant.price
        };
      }
    } else if (intId === addOn.id) {
      return addOn;
    }
  }
}

function getShopifyCurrencyFormat() {
  if (window.money_format) {
    return window.money_format;
  }

  if (window.theme && window.theme.moneyFormat) {
    return window.theme.moneyFormat;
  }

  return Shopify.money_format;
}

function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || '${{amount}}';

  function defaultOption(opt, def) {
    return typeof opt === 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number === null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'", '.');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}
